import styled, { css } from 'styled-components'
import { device } from '../../styles/Breakpoints'
import { Container } from '../../styles/Wrappers'
import { GridCallOutText, GridColumn, GridContent, GridLink, GridMedia } from '../Grids/Grid.styles'

export const GridSection = styled(Container)`
	${GridColumn} {
		align-items: center;

		${GridCallOutText} {
			text-align: center;
		}

		${GridContent} {
			text-align: center;

			img {
				margin: 0 auto;
			}
		}

		${GridLink} {
			position: static;
			height: unset;

			a {
				margin: 0 auto;
			}
		}
	}
`

export const CallOutTitle = styled.h2`
	text-align: center;
	padding-bottom: 0.5em;

	@media ${device.sm} {
		padding-bottom: 0.8em;
	}
`

export const CallOutDescription = styled.h3`
	text-align: center;
	max-width: 80ch;
	margin: 0 auto;
	padding-bottom: 1em;
`

export const CallOutMainCTA = styled.div`
	display: block;
	text-align: center;
	padding-top: 1em;

	a {
		display: inline-block;
		text-decoration: none;
	}
`

export const CallOutContainer = styled.div`
	${({ colorlist }) =>
		colorlist &&
		css`
			background-image: linear-gradient(90deg, ${colorlist.value} 0%, ${colorlist.light} 100%);
		`};

	${({ bgImage }) =>
		bgImage &&
		css`
			background-color: var(--grey-44);

			@media ${device.xs} {
				background: url('${bgImage.asset.url}') var(--grey-44);
				background-position: center;
				background-size: cover;
			}
		`};

	${GridLink} {
		padding-top: unset;
	}

	${GridSection} {
		&.green,
		&.solidgreen {
			color: var(--black);

			${GridCallOutText} {
				color: var(--dark-grey);
			}

			a.button {
				background-color: var(--white);
				border: 2px solid var(--dark-grey);
				text-decoration: none;

				&:hover,
				&:focus {
					background-color: var(--dark-grey);
					color: var(--white);
				}
			}

			a {
				color: var(--black);
				text-decoration: underline;

				&:hover,
				&:focus {
					color: var(--dark-grey-22);
				}
			}
		}

		&.darkgrey,
		&.soliddarkgrey {
			color: var(--white);

			${GridCallOutText} {
				color: var(--white);
			}

			a:not(.button) {
				color: var(--white);
				text-decoration: underline;

				&:hover,
				&:focus {
					color: var(--green);
				}
			}
		}

		&.grey,
		&.solidgrey {
			a:not(.button) {
				font-weight: 700;
			}
		}
	}

	${GridMedia} {
		height: 50px;
		flex: 0 0 50px;

		img {
			width: unset;
			max-width: 100%;
		}
	}
`

export const CallOutOneColumnGridContainer = styled.div`
	display: grid;
`

export const CallOutTwoColumnGridContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 2rem;

	@media ${device.xs} {
		grid-template-columns: repeat(2, minmax(200px, 350px));
		justify-content: center;

		${GridColumn} {
			align-items: normal;
			text-align: ${(props) => (props.center ? 'center' : 'left')};

			${GridCallOutText} {
				text-align: ${(props) => (props.center ? 'center' : 'left')};
			}

			${GridContent} {
				text-align: ${(props) => (props.center ? 'center' : 'left')};

				img {
					margin: ${(props) => (props.center ? '0 auto' : '0')};
				}
			}

			${GridLink} {
				a {
					margin: ${(props) => (props.center ? '0 auto' : '0')};
				}
			}

			${GridMedia} {
				margin: ${(props) => (props.center ? '0 auto' : '0')};
			}
		}
	}

	@media ${device.lg} {
		grid-gap: 12rem;
	}
`

export const CallOutThreeColumnGridContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 32px;

	@media ${device.xs} {
		grid-template-columns: repeat(2, minmax(200px, 1fr));

		${GridColumn} {
			align-items: normal;
			text-align: ${(props) => (props.center ? 'center' : 'left')};

			${GridCallOutText} {
				text-align: ${(props) => (props.center ? 'center' : 'left')};
			}

			${GridContent} {
				text-align: ${(props) => (props.center ? 'center' : 'left')};

				img {
					margin: ${(props) => (props.center ? '0 auto' : '0')};
				}
			}

			${GridLink} {
				a {
					margin: ${(props) => (props.center ? '0 auto' : '0')};
				}
			}

			${GridMedia} {
				margin: ${(props) => (props.center ? '0 auto' : '0')};
			}
		}
	}

	@media ${device.sm} {
		grid-template-columns: repeat(3, minmax(200px, 1fr));
	}
`
export const CallOutFourColumnGridContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 32px;

	@media ${device.xs} {
		grid-template-columns: repeat(2, minmax(200px, 1fr));

		${GridColumn} {
			align-items: normal;
			text-align: ${(props) => (props.center ? 'center' : 'left')};

			${GridCallOutText} {
				text-align: ${(props) => (props.center ? 'center' : 'left')};
			}

			${GridContent} {
				text-align: ${(props) => (props.center ? 'center' : 'left')};

				img {
					margin: ${(props) => (props.center ? '0 auto' : '0')};
				}
			}

			${GridLink} {
				a {
					margin: ${(props) => (props.center ? '0 auto' : '0')};
				}
			}

			${GridMedia} {
				margin: ${(props) => (props.center ? '0 auto' : '0')};
			}
		}
	}

	@media ${device.md} {
		grid-template-columns: repeat(4, minmax(200px, 1fr));
	}
`
